var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "hover-overlay-link",
      attrs: { target: "_blank", href: _vm.href },
      on: { click: _vm.handleClick },
    },
    [
      _vm.showOverlay
        ? _c("div", { staticClass: "hover-overlay-layer" }, [
            _c("div", { staticClass: "hover-overlay-center" }, [
              _c("div", { staticClass: "hover-overlay-icon icon-zoom-in" }, [
                _c("i", { class: _vm.iconRender }),
              ]),
              _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }